// Curated placeholder media for an advertising creative director's portfolio.
// The user will replace these with their own uploads later.
// Mix of image-only sections and ambient video-background sections.

const IMG = {
  // User-uploaded images for sections 01-05
  user01:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/v9vxd08j_8CF116C6-7B62-4150-ABD2-867A92B89304.png",
  user02:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/u5wecy1e_nikespqrnew.png",
  user03:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/z7sq8kbq_10011.jpg",
  user04:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/cnztakv6_10012.jpg",
  user05:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/wybptiww_reddevilsnewok.png",
  user06:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/7j42qkt6_10001.jpg",
  user07:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/gf29xi0r_10002.jpg",
  user08:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/7stdz03o_10003.jpg",
  user09:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/aglbo11z_10004.jpg",
  user10:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/pnl0xjsa_10005.jpg",
  user11:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/v3a9lr9e_8834f545-c355-4afd-9372-c8aaf797ddd8.png",
  user12:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/x0snwsno_b65d2e70-6492-4ec5-962c-b73844b88506.png",
  user13:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/0gvbo3y6_cocacolaman.png",
  user14:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/47w3f9u1_7f3ae249-f43c-47c2-ad68-9baaec2aeb54.png",
  user15:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/7qx5bni7_D6125700-AE1C-4F28-B824-ADC63A7717FF.png",
  user16:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/ro2phns5_10021.jpg",
  user17:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/kt7wf6jx_10024.jpg",
  user18:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/8nuwt475_10027.jpg",
  user19:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/ur6mzogo_10028-topaz-upscale-4x.jpg",
  user20:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/0n0t63tv_10030.jpg",
  user21:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/acu4wr1m_tweetrace.png",
  user22:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/0y7jg58e_nike-camp-02.png",
  user23:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/pcrjl7t0_10017.jpg",
  user24:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/c9y7jg3t_10018.jpg",
  user25:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/4b1knrrh_kris-andrew-small-adidas-pride-i.format-webp.width-2880_OfoEWbcIahEPVez0.webp",
  user26:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/t3fgukvg_Screenshot%202026-06-17%20at%2013.35.41.JPG",
  // IKEA Japan 10 catalogues — Project 15 hero (added 2026-06-23).
  ikeaJapan:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/vf9vn5au_lucagrelli-5bbc90e024cfc6a%402x.jpg",
  // Welcome to Masterdam — Nike Netherlands (added 2026-06-23).
  masterdam:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/j8sgseqb_masterdam.png",
  // Luca Grelli intro (Project 01) sub-page frame images
  lucaIntro1:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/5oul052x_lucagrelli-5e1d70cb265cd17%402x.jpg",
  lucaIntro2:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/08j0gbhg_lucagrelli-5da7b9342623279%402x.jpg",
  lucaIntro3:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/5anqbv4l_lucagrelli-5da7c4bf26236f8%402x.jpg",
  lucaIntro4:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/cvj6n0py_lucagrelli-5e1d7056265cd08%402x.jpg",
  stone1:
    "https://images.unsplash.com/photo-1555181937-efe4e074a301?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  fashion1:
    "https://images.unsplash.com/photo-1650339157791-75f7f3d5bc36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  arch1:
    "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  fashion2:
    "https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  arch2:
    "https://images.unsplash.com/photo-1552821773-37cbce3a7965?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  stone2:
    "https://images.unsplash.com/photo-1565419672978-6ba05e8859d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  fashion3:
    "https://images.unsplash.com/photo-1571513800374-df1bbe650e56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
};

const VID = {
  bookTrailer:
    "https://customer-assets.emergentagent.com/job_gallery-scroll/artifacts/2csp4cwu_booktrailer2026-Broadband%20High.mp4",
  // Tiny self-hosted preview loop (~100 KB) that paints instantly while the
  // full bookTrailer mp4 (~14 MB) is downloading in the background.
  // The `?v=` cache-bust suffix forces mobile browsers to re-fetch the file
  // contents after we regenerate the preview — without it, Safari/Chrome
  // mobile will keep serving the stale cached bytes by filename even after
  // we've overwritten /media/booktrailer-preview.{webm,mp4} on disk.
  bookTrailerPreviewWebm: "/media/booktrailer-preview.webm?v=2026-broadband",
  bookTrailerPreviewMp4: "/media/booktrailer-preview.mp4?v=2026-broadband",
  bookTrailerPoster: "/media/booktrailer-poster.jpg?v=2026-broadband",
  // Lightweight, royalty-free ambient stock loops
  fabric:
    "https://cdn.coverr.co/videos/coverr-a-silk-fabric-blowing-in-the-wind-2633/1080p.mp4",
  smoke:
    "https://cdn.coverr.co/videos/coverr-slow-motion-of-white-smoke-3949/1080p.mp4",
  cityRain:
    "https://cdn.coverr.co/videos/coverr-rain-on-a-window-at-night-9249/1080p.mp4"
};

const align = [
  "items-end justify-start text-left pl-8 md:pl-16 pb-24",
  "items-center justify-center text-center px-8",
  "items-start justify-end pt-32 pr-8 md:pr-16 text-right",
  "items-start justify-start pt-32 pl-8 md:pl-16 text-left",
  "items-end justify-end pb-24 pr-8 md:pr-16 text-right"
];

export const projects = [
  {
    title: "Luca Grelli - ECD/Creative director",
    client: "",
    role: "",
    year: "",
    discipline: "Film",
    blurb: "",
    media: {
      type: "video",
      src: VID.bookTrailer,
      preview: { webm: VID.bookTrailerPreviewWebm, mp4: VID.bookTrailerPreviewMp4 },
      poster: VID.bookTrailerPoster
    },
    filter: "none"
  },
  {
    title: "Aperture",
    client: "Maison Lévy",
    role: "Concept · Art Direction",
    year: "2026",
    discipline: "Print Campaign",
    blurb:
      "A study in restraint. A campaign built around a single gesture, told in five frames.",
    media: { type: "image", src: IMG.user01 },
    filter: "none"
  },
  {
    title: "Concrete Poetry",
    client: "Stadt Architekten",
    role: "Identity · Campaign",
    year: "2025",
    discipline: "Brand World",
    blurb:
      "Architecture as language. A wordmark carved from the negative space of a stairwell.",
    media: { type: "image", src: IMG.user03 },
    filter: "none"
  },
  {
    title: "Soft Power",
    client: "Issei Cosmetics",
    role: "Global Campaign Lead",
    year: "2025",
    discipline: "Out-of-Home",
    blurb:
      "Repositioning a 40-year-old skincare house for a generation that doesn't trust polish.",
    media: { type: "image", src: IMG.user04 },
    filter: "none"
  },
  {
    title: "The Long Pause",
    client: "Onda Spirits",
    role: "Campaign · Film",
    year: "2024",
    discipline: "Brand Film",
    blurb: "A 60-second commercial with 22 seconds of black. The risk was the point.",
    media: { type: "image", src: IMG.user05 },
    filter: "none"
  },
  {
    title: "Quiet Luxury",
    client: "Holm & Holm",
    role: "Brand Repositioning",
    year: "2024",
    discipline: "Strategy · Identity",
    blurb: "Less typeface, less colour, less product. Three percent more revenue.",
    media: { type: "image", src: IMG.user07 },
    filter: "none"
  },
  {
    title: "Twelve Rooms",
    client: "Selfridges",
    role: "Window Campaign",
    year: "2024",
    discipline: "Retail · Spatial",
    blurb:
      "A holiday window series built around twelve voices, no music, and one continuous tracking shot.",
    media: { type: "image", src: IMG.user08 },
    filter: "none"
  },
  {
    title: "Untitled, Spring",
    client: "Norse Projects",
    role: "Seasonal Campaign",
    year: "2024",
    discipline: "Fashion",
    blurb:
      "Eighteen photographs, no copy, no logo placement. Sold out in nine days.",
    media: { type: "image", src: IMG.user09 },
    filter: "none"
  },
  {
    title: "Counterweight",
    client: "Allbirds",
    role: "Brand Campaign",
    year: "2024",
    discipline: "Integrated",
    blurb:
      "Honest claims, honest weight. A campaign that begins where most sustainability ads end.",
    media: { type: "image", src: IMG.user10 },
    filter: "none"
  },
  {
    title: "Project 22",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user11 },
    filter: "none"
  },
  {
    title: "Project 23",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user12 },
    filter: "none"
  },
  {
    title: "Project 24",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user26 },
    filter: "none"
  },
  {
    title: "Project 25",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user14 },
    filter: "none"
  },
  {
    title: "Project 26",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user15 },
    filter: "none"
  },
  {
    title: "IKEA Japan",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.ikeaJapan },
    filter: "none"
  },
  {
    title: "Project 15",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user16 },
    filter: "none"
  },
  {
    title: "Project 16",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user17 },
    filter: "none"
  },
  {
    title: "Project 17",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user18 },
    filter: "none"
  },
  {
    title: "Project 18",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user19 },
    filter: "none"
  },
  {
    title: "Project 19",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user20 },
    filter: "none"
  },
  {
    title: "Project 20",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user21 },
    filter: "none"
  },
  {
    title: "Project 21",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user22 },
    filter: "none"
  },
  {
    title: "Project 22",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user23 },
    filter: "none"
  },
  {
    title: "Project 23",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user24 },
    filter: "none"
  },
  {
    title: "Project 24",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user25 },
    filter: "none"
  },
  {
    title: "Welcome to Masterdam",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.masterdam },
    filter: "none"
  },
  {
    title: "Project 25",
    client: "",
    role: "",
    year: "",
    discipline: "",
    blurb: "",
    media: { type: "image", src: IMG.user13 },
    filter: "none"
  }
];

export const sectionAlignment = (i) => align[i % align.length];

// Auto-assign a stable slug to every project: project-01, project-02, ...
// Also use the project's own media as its transition (case-study) hero image,
// so the cross-fade lands on the same image that was clicked.
projects.forEach((p, i) => {
  if (!p.slug) p.slug = `project-${String(i + 1).padStart(2, "0")}`;
  if (!p.transitionImage) {
    p.transitionImage = p.media?.poster || p.media?.src;
  }
});

// Lookup helpers used by the case-study sub-page.
export const findProjectBySlug = (slug) =>
  projects.findIndex((p) => p.slug === slug);

// Build 5 stacked frames for a sub-page: frame[0] = the clicked image,
// frames[1..4] = next images from the project pool (skipping the clicked one).
export const buildCaseStudyFrames = (projectIndex) => {
  if (projectIndex < 0 || projectIndex >= projects.length) return [];
  const project = projects[projectIndex];
  const hero = project.transitionImage;
  const pool = projects
    .map((p) => p.media?.poster || p.media?.src)
    .filter(Boolean);
  const seen = new Set([hero]);
  const rest = [];
  // Start from the project's neighbours and wrap around for variety.
  for (let step = 1; rest.length < 4 && step < pool.length + 1; step++) {
    const candidate = pool[(projectIndex + step) % pool.length];
    if (candidate && !seen.has(candidate)) {
      seen.add(candidate);
      rest.push(candidate);
    }
  }
  return [hero, ...rest];
};

